import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Field, Sel, opts } from "@/components/Field";
import { FormDialog, useSubmit, num, clean } from "./FormDialog";

const EMPTY = { name: "", code: "", barcode: "", category: "", description: "", unit: "", min_stock: "", location: "", notes: "", purchase_price: "", sale_price: "" };

export const ProductDialog = ({ open, onOpenChange, product, onSaved }) => {
  const { assoc } = useAuth();
  const [f, setF] = useState(EMPTY);
  const { saving, run } = useSubmit();
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v?.target ? v.target.value : v }));

  useEffect(() => {
    if (open) setF(product ? { ...EMPTY, ...Object.fromEntries(Object.keys(EMPTY).map((k) => [k, product[k] ?? ""])) } : { ...EMPTY, unit: assoc?.units?.[0] || "", location: assoc?.locations?.[0] || "" });
  }, [open, product, assoc]);

  const submit = () =>
    run(async () => {
      const body = clean({ ...f, min_stock: num(f.min_stock), purchase_price: num(f.purchase_price), sale_price: num(f.sale_price) });
      const { data } = product ? await api.patch(`/products/${product.id}`, body) : await api.post("/products", body);
      onOpenChange(false);
      onSaved?.(data);
    }, product ? "Prodotto aggiornato" : "Prodotto creato");

  return (
    <FormDialog open={open} onOpenChange={onOpenChange} title={product ? "Modifica prodotto" : "Nuovo prodotto"} onSubmit={submit} saving={saving} testId="product-dialog">
      <Field label="Nome *" htmlFor="p-name"><Input id="p-name" data-testid="product-name-input" required value={f.name} onChange={set("name")} className="h-11" /></Field>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Categoria"><Sel testId="product-category-select" value={f.category} onChange={set("category")} options={opts(assoc?.categories)} placeholder="—" /></Field>
        <Field label="Unità di misura *"><Sel testId="product-unit-select" value={f.unit} onChange={set("unit")} options={opts(assoc?.units)} /></Field>
        <Field label="Ubicazione"><Sel testId="product-location-select" value={f.location} onChange={set("location")} options={opts(assoc?.locations)} placeholder="—" /></Field>
        <Field label="Scorta minima" hint="Facoltativa"><Input data-testid="product-minstock-input" type="number" min="0" step="any" value={f.min_stock} onChange={set("min_stock")} className="h-11" /></Field>
        <Field label="Codice prodotto"><Input data-testid="product-code-input" value={f.code} onChange={set("code")} className="h-11" /></Field>
        <Field label="Codice a barre"><Input data-testid="product-barcode-input" value={f.barcode} onChange={set("barcode")} className="h-11" /></Field>
        <Field label="Prezzo d'acquisto (CHF)" hint="Per unità, si aggiorna con le entrate"><Input data-testid="product-purchase-price-input" type="number" min="0" step="0.05" value={f.purchase_price} onChange={set("purchase_price")} className="h-11" /></Field>
        <Field label="Prezzo di vendita (CHF)" hint="Per unità, usato nelle fatture"><Input data-testid="product-sale-price-input" type="number" min="0" step="0.05" value={f.sale_price} onChange={set("sale_price")} className="h-11" /></Field>
      </div>
      <Field label="Descrizione"><Textarea data-testid="product-description-input" value={f.description} onChange={set("description")} rows={2} /></Field>
      <Field label="Note"><Textarea data-testid="product-notes-input" value={f.notes} onChange={set("notes")} rows={2} /></Field>
    </FormDialog>
  );
};
